<template>
    <div class="fx-event-listing-date-component">
        <div v-if="event.is_date_tbd">
            <span class="date-row">Date</span>
            <span class="date-row">TBD</span>
        </div>
        <div v-else-if="event.is_time_tbd">
            <span class="date-row">{{ event.local_date | date('ddd') }}</span>
            <span
                class="date-row"
                data-e2e="event-date">{{ event.local_date | date('MMM D') }}</span>
            <span class="date-row">
                {{ event.local_date | date('YYYY') }}
            </span>
            <span class="date-row time-tbd">
                <span class="icon-clock"></span>
                TBD
            </span>
        </div>
        <div v-else>
            <span class="date-row">{{ event.local_date | date('ddd') }}</span>
            <span
                class="date-row"
                data-e2e="event-date">{{ event.local_date | date('MMM D') }}</span>
            <span class="date-row">
                {{ event.local_date | date('YYYY') }}
            </span>
            <span class="date-row">{{ event.local_date | date('h:mma') }}</span>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        event: {
            required: true
        }
    }
}
</script>

<style lang="postcss" scoped>
@import 'theme';

.date-row {
    display: block;
    color: var(--c-gray-4);
    font-weight: var(--fw-light);
    white-space: nowrap;
    &:nth-child(2) {
        color: var(--c-gray-1);
        font-size: var(--fs-larger);
        font-weight: 500;
    }
    &.time-tbd {
        display: flex;
        align-items: center;
    }
    & > .icon-clock {
        display: inline-flex;
    }
}
</style>
